export enum EFormStatus {
  Init = 'init',
  Loading = 'loading',
  Success = 'success',
  Failed = 'failed',
}

export type TFormStatus = {
  status: EFormStatus;
};

export type TSendFormParams = {
  phone: string;
  polygon: string;
  source: string;
  legalAgreementAccepted?: boolean;
};

export type TFormProps = {
  theme: 'white' | 'black';
  isModalForm?: boolean;
  title?: string;
  subtitle?: string;
  btnTitle?: string;
};
